export const faqCategories = [
    {
        id: 'authentication',
        title: 'Authentification',
        icon: 'VpnKey',
        description: 'Questions sur OAuth2, tokens, clés API'
    },
    {
        id: 'payment',
        title: 'Paiements',
        icon: 'Payment',
        description: 'Création de paiements, vérification, statuts'
    },
    {
        id: 'webhooks',
        title: 'Webhooks',
        icon: 'Notifications',
        description: 'Configuration, signatures, retries'
    },
    {
        id: 'errors',
        title: 'Erreurs',
        icon: 'Error',
        description: 'Codes d\'erreur, dépannage'
    },
    {
        id: 'general',
        title: 'Général',
        icon: 'Help',
        description: 'Questions générales sur l\'API'
    }
];

export const faqData = {
    authentication: [
        {
            question: 'Comment obtenir mes clés API (Client ID et Client Secret) ?',
            answer: 'Pour obtenir vos clés API, vous devez d\'abord créer un compte développeur sur https://gateway.netikash.com. Ensuite, allez dans votre espace développeur, sélectionnez une organisation et le rôle développeur. Si vous n\'avez pas le rôle développeur, continuez en tant qu\'admin et allez dans l\'onglet "Gestion d\'utilisateur et rôle" pour vous ajouter comme développeur. Après reconnexion, allez dans "Clés et Application", cliquez sur "Créer une nouvelle application" et récupérez vos Client ID et Client Secret.',
            links: [
                { text: 'Voir la documentation d\'authentification', url: '/documentation?section=authorization' },
                { text: 'Guide de démarrage', url: '/documentation?section=introduction' }
            ]
        },
        {
            question: 'Mon token d\'accès a expiré, que faire ?',
            answer: 'Les tokens d\'accès OAuth2 ont une durée de validité limitée (généralement 3600 secondes). Si votre token a expiré, vous devez simplement en demander un nouveau en faisant un nouvel appel à l\'endpoint d\'authentification avec vos credentials. Il est recommandé d\'implémenter un système de rafraîchissement automatique du token avant expiration.',
            links: [
                { text: 'Documentation OAuth2', url: '/documentation?section=authorization' }
            ]
        },
        {
            question: 'Comment sécuriser mes clés API ?',
            answer: 'Ne partagez JAMAIS vos clés API avec des tiers. Ne commitez jamais vos clés dans votre code source public (GitHub, GitLab, etc.). Utilisez toujours des variables d\'environnement pour stocker vos clés. En production, utilisez un gestionnaire de secrets sécurisé (AWS Secrets Manager, HashiCorp Vault, etc.). Si vos clés sont compromises, révoquez-les immédiatement depuis votre espace développeur et créez de nouvelles clés.',
            links: [
                { text: 'Best practices de sécurité', url: '/security' }
            ]
        },
        {
            question: 'Puis-je utiliser plusieurs applications avec différentes clés API ?',
            answer: 'Oui, vous pouvez créer plusieurs applications depuis votre espace développeur. Chaque application aura son propre Client ID et Client Secret. C\'est une bonne pratique de créer des applications séparées pour différents environnements (développement, staging, production) ou pour différents projets.',
            links: []
        }
    ],
    payment: [
        {
            question: 'Comment créer une demande de paiement ?',
            answer: 'Pour créer une demande de paiement, vous devez d\'abord obtenir un token d\'accès via l\'endpoint d\'authentification. Ensuite, faites un POST vers l\'endpoint de création de paiement avec les informations requises : amount (montant), currency (USD ou CDF), ref (référence de votre commande), et referer_url (URL de redirection après paiement). L\'API vous retournera un payment_link vers lequel vous devez rediriger votre utilisateur.',
            links: [
                { text: 'Documentation des paiements', url: '/documentation?section=payment-request' },
                { text: 'Exemples de code', url: '/examples?tab=payment' }
            ]
        },
        {
            question: 'Quels sont les statuts possibles d\'un paiement ?',
            answer: 'Les principaux statuts sont : pending (en attente), completed (terminé avec succès), failed (échoué), expired (expiré), locked (bloqué), et canceled (annulé). Vous pouvez vérifier le statut d\'un paiement en utilisant l\'endpoint de vérification avec la référence du paiement.',
            links: [
                { text: 'Vérification de paiement', url: '/documentation?section=payment-verification' }
            ]
        },
        {
            question: 'Combien de temps un lien de paiement est-il valide ?',
            answer: 'La durée de validité d\'un lien de paiement est définie dans la réponse de l\'API lors de la création de la demande. Cette information est disponible dans le champ expires_at. Il est recommandé de vérifier ce champ et de gérer les paiements expirés dans votre application.',
            links: []
        },
        {
            question: 'Comment vérifier le statut d\'un paiement ?',
            answer: 'Vous pouvez vérifier le statut d\'un paiement en faisant un GET vers l\'endpoint de vérification avec la référence (ref) de votre paiement. Vous recevrez également des webhooks lorsque le statut change, mais il est recommandé de toujours vérifier côté serveur avant de confirmer un paiement.',
            links: [
                { text: 'Vérification de paiement', url: '/documentation?section=payment-verification' },
                { text: 'Webhooks', url: '/documentation?section=webhooks' }
            ]
        },
        {
            question: 'Quelles devises sont supportées ?',
            answer: 'Actuellement, Netikash supporte USD (Dollar américain) et CDF (Franc congolais). Les devises doivent être spécifiées en majuscules dans vos requêtes.',
            links: []
        }
    ],
    webhooks: [
        {
            question: 'Comment configurer mes webhooks ?',
            answer: 'Pour configurer vos webhooks, connectez-vous à votre espace développeur, allez dans la section "Webhooks" et configurez votre URL de webhook. Vous pouvez également sélectionner les événements dont vous souhaitez être notifié. Assurez-vous que votre endpoint webhook est accessible publiquement via HTTPS.',
            links: [
                { text: 'Documentation des webhooks', url: '/documentation?section=webhooks' }
            ]
        },
        {
            question: 'Comment vérifier la signature d\'un webhook ?',
            answer: 'Les webhooks Netikash incluent des en-têtes X-Signature et X-Timestamp pour vérifier l\'authenticité. Pour vérifier la signature, vous devez reconstruire la signature en utilisant votre secret de webhook, le timestamp et le body de la requête. Consultez la documentation pour des exemples de code dans différents langages.',
            links: [
                { text: 'Exemples de vérification', url: '/examples?tab=webhooks' },
                { text: 'Documentation webhooks', url: '/documentation?section=webhooks' }
            ]
        },
        {
            question: 'Que se passe-t-il si mon endpoint webhook ne répond pas ?',
            answer: 'Si votre endpoint webhook ne répond pas avec un code HTTP 2xx, Netikash tentera de renvoyer le webhook jusqu\'à 5 fois sur une période de 24 heures, avec des intervalles exponentiels (1min, 5min, 30min, 2h, 6h). Assurez-vous que votre endpoint est robuste et répond rapidement.',
            links: [
                { text: 'Stratégie de retry', url: '/documentation?section=webhook-retries' }
            ]
        },
        {
            question: 'Quels événements webhook sont disponibles ?',
            answer: 'Les événements webhook disponibles incluent : payment.success (paiement confirmé), payment.cashed (montant disponible), payment.failed (paiement échoué), payment.expired (paiement expiré), payment.locked (paiement bloqué), et payment.canceled (paiement annulé).',
            links: [
                { text: 'Types d\'événements', url: '/documentation?section=webhooks' }
            ]
        }
    ],
    errors: [
        {
            question: 'J\'obtiens une erreur 401 Unauthorized, que faire ?',
            answer: 'Une erreur 401 signifie généralement que votre token d\'accès est invalide ou expiré. Vérifiez que vous incluez bien le token dans l\'en-tête Authorization avec le format "Bearer <token>". Si le problème persiste, demandez un nouveau token d\'accès.',
            links: [
                { text: 'Codes d\'erreur', url: '/error-codes' },
                { text: 'Authentification', url: '/documentation?section=authorization' }
            ]
        },
        {
            question: 'Erreur 429 Too Many Requests - comment gérer les rate limits ?',
            answer: 'L\'erreur 429 indique que vous avez dépassé la limite de taux autorisée. Vérifiez les en-têtes de réponse X-RateLimit-Limit, X-RateLimit-Remaining, et X-RateLimit-Reset pour gérer vos requêtes. Implémentez une stratégie de retry avec exponential backoff. La limite par défaut est de 100 requêtes par minute par IP/clé API.',
            links: [
                { text: 'Rate limits', url: '/documentation?section=rate-limits' }
            ]
        },
        {
            question: 'Erreur 422 Unprocessable Entity - que signifie-t-elle ?',
            answer: 'L\'erreur 422 indique que votre requête est syntaxiquement correcte mais contient des erreurs de validation sémantique. Vérifiez les champs requis, les formats de données (par exemple, currency doit être USD ou CDF en majuscules), et les contraintes de validation. Le body de la réponse contient généralement les détails des erreurs.',
            links: [
                { text: 'Codes d\'erreur HTTP', url: '/documentation?section=http-status-codes' }
            ]
        },
        {
            question: 'Comment éviter les doubles paiements ?',
            answer: 'Pour éviter les doubles paiements, utilisez des clés d\'idempotence (Idempotency-Key) avec une valeur unique (UUIDv4 recommandé) pour chaque requête POST/PUT sensible. Si une requête avec la même clé est reçue dans une fenêtre de temps, la réponse de la première requête réussie sera renvoyée sans réexécuter l\'opération.',
            links: [
                { text: 'Idempotence', url: '/documentation?section=idempotency' }
            ]
        }
    ],
    general: [
        {
            question: 'Quelle est la différence entre l\'environnement Sandbox et Production ?',
            answer: 'L\'environnement Sandbox est un environnement de test où vous pouvez tester vos intégrations sans effectuer de vrais paiements. L\'environnement Production est l\'environnement réel où les transactions sont réelles. Utilisez Sandbox pour le développement et les tests, et Production uniquement quand vous êtes prêt à aller en ligne.',
            links: [
                { text: 'Guide de démarrage', url: '/documentation?section=introduction' }
            ]
        },
        {
            question: 'Où puis-je trouver de l\'aide supplémentaire ?',
            answer: 'Vous pouvez consulter notre documentation complète, nos exemples de code, ou contacter notre équipe de support technique. Nous offrons également un centre d\'aide avec des tutoriels et des guides.',
            links: [
                { text: 'Centre d\'aide', url: '/help-center' },
                { text: 'Support technique', url: '/technical-support' },
                { text: 'Contact', url: '/contact' }
            ]
        },
        {
            question: 'Netikash supporte-t-il plusieurs langages de programmation ?',
            answer: 'Oui, Netikash fournit des exemples de code et une documentation pour de nombreux langages populaires : Node.js, Python, PHP, TypeScript, Go, cURL, et plus. Vous pouvez consulter nos exemples de code pour voir des implémentations dans votre langage préféré.',
            links: [
                { text: 'Exemples de code', url: '/examples' }
            ]
        },
        {
            question: 'Comment recevoir les mises à jour de l\'API ?',
            answer: 'Vous pouvez consulter notre page de changelog pour voir les mises à jour récentes de l\'API. Nous recommandons également de vous abonner à notre newsletter pour recevoir les dernières actualités. Les changements importants sont également annoncés dans la documentation.',
            links: [
                { text: 'Changelog', url: '/changelog' }
            ]
        },
        {
            question: 'Quelle est la disponibilité des services Netikash ?',
            answer: 'Nous visons une disponibilité de 99.9% pour nos services API. Vous pouvez consulter notre page de statut en temps réel pour voir l\'état actuel des services et l\'historique des incidents.',
            links: [
                { text: 'Statut des services', url: '/status' }
            ]
        }
    ]
};